import {Component, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild, ElementRef, NgZone } from "@angular/core";
import { ExerciseData } from "src/app/modules/algebrakit/types/algebrakit.types";

@Component({
    selector: "app-exercise-data",
    templateUrl: "./exercise-data.component.html",
    styleUrls: ["./exercise-data.component.less"],
    standalone: false
})
export class ExerciseDataComponent  {
    @Input() exerciseData: ExerciseData;
    @Input() activeRefId: string;

    @Output() interactionSelected: EventEmitter<string> = new EventEmitter<string>();

    viewInteraction(refId: string) {
        this.interactionSelected.emit(refId);
    }

    clearRefId() {
        this.interactionSelected.emit(null);
    }
    
}
